import * as SportType from 'constants/SportType';

const cssClassMap = {
    [SportType.TABLE_TENNIS]: 'ttennis',
    [SportType.BEACH_VOLLEYBALL]: 'beachvolley',
    [SportType.VOLLEYBALL]: 'volley',
    [SportType.BOX]: 'box',
    [SportType.TENNIS]: 'tennis',
    [SportType.FOOTBALL]: 'soccer',
    [SportType.ICE_HOCKEY]: 'icehockey',
    [SportType.HANDBALL]: 'handball',
    [SportType.BASEBALL]: 'baseball',
    [SportType.CYBER_SPORTS]: 'cybersports',
    [SportType.LOTTERY]: 'lottery',
    [SportType.AMERICAN_FOOTBAL]: 'americanfootball',
    [SportType.BANDY]: 'bandy',
    [SportType.BASKETBALL]: 'basketball',
    [SportType.BADMINTON]: 'badminton',
    [SportType.FUTSAL]: 'futsal',
    [SportType.FLOORBALL]: 'floorball',
    [SportType.WEATHER]: 'weather',
    [SportType.WATER_POLLO]: 'waterpolo',
    [SportType.BIATHLON]: 'biathlon',
    [SportType.BEACH_FOOTBALL]: 'beachsoccer',
    [SportType.MARTIAL_ARTS]: 'wrestling',
    [SportType.FORMULA1]: 'formula1',
    [SportType.CYCLING]: 'cycling',
    [SportType.ELECTIONS]: 'election',
    [SportType.DARTS]: 'darts',
    [SportType.KVN]: 'kvn',
    [SportType.CULTURE]: 'culture',
    [SportType.ATHLETICS]: 'athletics',
    [SportType.SKIING]: 'skiing',
    [SportType.OLYMPIC]: 'olimpicgames',
    [SportType.SWIMMING]: 'swimming',
    [SportType.POKER]: 'pocker',
    [SportType.RUGBY]: 'rugby',
    [SportType.HOCKEY]: 'hockeygras',
    [SportType.WHAT_WHERE_WHEN]: 'whatwherewhen',
    [SportType.CHESS]: 'chess',
    [SportType.SNOOKER]: 'pool'
};

export {cssClassMap};



// WEBPACK FOOTER //
// ./js/rendering-commons/SportCssMap.js